import { render, staticRenderFns } from "./SubscriptionProductTypeDialog.vue?vue&type=template&id=2622cedb&scoped=true&"
import script from "./SubscriptionProductTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SubscriptionProductTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622cedb",
  null
  
)

export default component.exports